import type { UiPreferencesResponse } from '../../services/endpoints/page/types';

const UI_PREFERENCES_DEFAULT_VALUES: Omit<
	UiPreferencesResponse,
	'schedulePreferences' | 'timeZoneType'
> & {
	schedulePreferences: Omit<UiPreferencesResponse['schedulePreferences'][0], 'id'>;
} = {
	displayDensity: 'slim',
	scheduleOrder: 'baseSchedule',
	schedulesCollapsed: false,
	showGaps: false,
	schedulePreferences: {
		collapsed: false,
		showAllLayers: false,
	},
};

export { UI_PREFERENCES_DEFAULT_VALUES };
